import React from 'react';
import CounterCard from '../../../../@jumbo/components/Common/CounterCard';

const TasksCounterCard = () => {
  return (
    <CounterCard
      icon={'http://sanchan-ott-resources.imgix.net/common/ottadmin/images/dashboard/tasksIcon.svg'}
      number="457"
      label="Tasks"
      labelProps={{
        fontSize: 16,
      }}
      backgroundColor={['#5AB9FE -18.96%', '#1372B7 108.17%']}
      gradientDirection="180deg"
    />
  );
};

export default TasksCounterCard;
